import React, { useState, useCallback, Fragment, useEffect } from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import FolderIcon from "@material-ui/icons/Folder";
import SettingsIcon from "@material-ui/icons/Settings";
import DescriptionIcon from "@material-ui/icons/Description";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { COLORS } from '../../styles/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faCheck, faTasks } from '@fortawesome/free-solid-svg-icons'
import {
  makeStyles,
} from "@material-ui/core/styles";
import blue from "@material-ui/core/colors/blue";
import pink from "@material-ui/core/colors/pink";
import superagent from "superagent";
import Tree from "material-ui-tree";
import getNodeDataByPath from "material-ui-tree/lib/util";
import ActionForm from './ActionForm';
import { AlertJsMessage, ConfirmJsMessage } from './../../helpers.js';

const useStyles = makeStyles({
  container: {
    marginTop: 5,
    padding: 0
  },
  icon: {
    fontSize: 20
  },
  node: {
    display: "flex",
    alignContent: "center"
  }
});

const TreeView = (props) => {
  const classes = useStyles();
  const [state, setState] = useState({
    alignRight: true,
    data: props.item,
    isOpenForm: false,
    formData: {}
  });

  useEffect(() => {
    setState({
      ...state,
      data: props.item
    })
  }, [props.item])

  const renderLabel = useCallback(
    (data, unfoldStatus) => {
      const { path, type, isCompleted } = data;
      let variant = "body1";
      let iconComp = null;
      if (type === "tree") {
        iconComp = <FontAwesomeIcon icon={faTasks} title={'Tasks'}
        style={{ marginRight: 5, color: COLORS.orange }} />;
      }
      return (
          <Typography variant={variant} className={classes.node}>
            { type === "tree" &&
             React.cloneElement(iconComp, { className: classes.icon })
             }
            <span>{path}</span>
          </Typography>
        )
      ;
    },
    [classes]
  );

  const getActionsData = useCallback(
    (data, path, unfoldStatus) => {
      const { type, isCompleted } = data;
      if (props.isPreview) {
        if(isCompleted) { 
          return [{
            icon: <FontAwesomeIcon icon={faCheck} style={{color: COLORS.orange }}/>,
            hint: "Completed"
          }]
        } else {
          return null
        }
      }
      if (type === "tree") {
        return [{
          icon: <FontAwesomeIcon icon={faPlus} style={{color: COLORS.orange }}/>,
          hint: "Add Step",
          onClick: () => {
            setState({
              ...state,
              isOpenForm: true,
              actionType: 'Step',
              formData: {}
            })
          }
        }, {
          icon: <FontAwesomeIcon icon="edit" style={{color: COLORS.orange}}/>,
          hint: "Edit Action",
          style: {
            "marginLeft": "0"
          },
          onClick: () => {
            const treeData = Object.assign({}, state.data);
            props.onEditAction(treeData)
          }
        },
        {
          icon: <FontAwesomeIcon icon={faTrash} style={{color: COLORS.orange, marginLeft: '0 !important' }}/>,
          hint: "Delete Action",
          style: {
            "marginLeft": "0"
          },
          onClick: () => {
            const treeData = Object.assign({}, state.data);
            props.onDeleteAction(treeData.clientId)
          }
        }];
      }
      return [
        {
          icon: <FontAwesomeIcon icon="edit" style={{color: COLORS.orange}}/>,
          hint: "Edit Sub Action",
          onClick: () => {
            const treeData = Object.assign({}, state.data);
            const parentData = getNodeDataByPath(
              treeData,
              path.slice(0, path.length - 1),
              "tree"
            );
            const lastIndex = path[path.length - 1];
            const data = treeData.tree[lastIndex];
            setState({
              ...state,
              isOpenForm: true,
              actionType: 'Step',
              formData: {
                title: data.path,
                _id: data._id,
                clientId: data.clientId
              },
              selectedIndex: lastIndex
            })
          }
        },
        {
          icon: <FontAwesomeIcon icon={faTrash} style={{color: COLORS.orange, marginLeft: '0 !important' }}/>,
          hint: "Delete Step",
          style: {
            "marginLeft": "0"
          },
          onClick: () => {
            const treeData = Object.assign({}, state.data);
            const tree = JSON.parse(JSON.stringify(treeData.tree));
            const parentData = getNodeDataByPath(
              treeData,
              path.slice(0, path.length - 1),
              "tree"
            );
            const lastIndex = path[path.length - 1];
            if (ConfirmJsMessage(`Are you sure you want to delete the Step?`)) {
              tree[lastIndex]['isDelete'] = true
              props.passData(props.item.clientId, tree[lastIndex])
              parentData.tree.splice(lastIndex, 1);
              setState({ ...state, data: treeData });
            }
          }
        }
      ];
    },
    [classes, state, setState]
  );

  const makeid = (length) =>  {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const onSave = () => {
    const { formData, selectedIndex } = state;
    const required = ['title'];
    for (var i = 0; i < required.length; i++) {
        if (!formData[required[i]]) {
            AlertJsMessage('Sub Action is required.');
            return;
        }
    }
    let { data } = state;
    let newData = {}
    if (formData.clientId) {
      let tree = data.tree;
      const findIndex = tree.findIndex((t) => {
        return t.clientId === formData.clientId
      })
      newData = {
        ...tree[findIndex],
        path: formData.title,
        isDelete: false
      };
      tree[findIndex] = newData;
      data['tree'] = tree;
    } else {
      let tree = data.tree;
      newData = {
        path: formData.title,
        clientId: makeid(10),
        isDelete: false
      }
      tree.push(newData)
      data['tree'] = tree;
    }
    setState({
      ...state,
      isOpenForm: false,
      data
    })
    props.passData(props.item.clientId, newData)
  }

  const handleChange = event => {
    const { name, value } = event.target;
    setState({
      ...state,
      formData: {
        ...state.formData,
        [name]: value,
      },
    });
  };

  return (
       <Fragment>
          {state.isOpenForm && (
              <ActionForm
                  isEdit={false}
                  hideAddModal={() => {
                      setState({
                          ...state,
                          isOpenForm: false
                      })
                  }}
                  isOpenFormModal = {state.isOpenForm}
                  onChange={handleChange}
                  actionType = {state.actionType}
                  formData={state.formData}
                  onSave={() => onSave()}
              />
          )}
      <Tree
        className={classes.container}
        title=""
        data={state.data}
        labelKey="path"
        valueKey="sha"
        childrenKey="tree"
        foldIcon={<ArrowDropDownIcon />}
        unfoldIcon={<ArrowDropUpIcon />}
        loadMoreIcon={<MoreHorizIcon />}
        unfoldAll={props.isPreview ? false : true}
        renderLabel={renderLabel}
        renderLoadMoreText={(page, pageSize, total) =>
          `Loaded: ${
            (page + 1) * pageSize
          } / Total: ${total}. Click here to load more...`
        }
        pageSize={10}
        actionsAlignRight={state.alignRight}
        getActionsData={getActionsData}
      />
      </Fragment>
  );
};


export default TreeView;


// WEBPACK FOOTER //
// ./src/components/assignments/TreeView.js